import Vue from 'vue';

/**
 * funcion que filtra la raza | variedad | subvariedad de perros  dependiendo del param lang
 * NOTA: sin uso actualmente el parametro name ni id
 */

Vue.filter('filterTranslateBreed', (name, id, objTrans, lang, retorno) => {

  let translation = objTrans.find(t => t.locale === lang);

  if (retorno === null || retorno === undefined) {
    return (translation.name +
      " | " +
      translation.subvariety +
      " | " +
      translation.variety
    );
  } else if (retorno === 'name') {
    return translation.name;
  } else if (retorno === 'variety') {
    return translation.variety;
  } else if (retorno === 'subvariety') {
    return translation.subvariety;
  }

});


/**
 *  funcion que filtra el idioma de la tabla de paises dependiendo del param lang
 */
Vue.filter('filterTranslateCountry', (name, id, objTrans, lang) => {

  return objTrans.find(t => t.locale === lang).name;

});

/**
 * funcion que filtra un string fecha y lo convierte a formato dd/mm/aaaa
 */
Vue.filter('filterDate', (date) => {

  let d = date.slice(0, 10).split("-");
  
  return d[2] + "/" + d[1] + "/" + d[0];

});